export default "__VITE_ASSET__D6oV4gcw__"